<template>
	<a-layout class="smart-home">
		<div class="left">
			<a-drawer :placement="placement" :closable="false" :visible="visibleDrawer" :width="200" @close="onClose">
				<a-layout-sider width="200" class="side" v-model="collapsed" :trigger="null" collapsible>
					<div class="logo">
						<img style="width:97px" :src="logoWhite" alt="" />
					</div>
					<div class="meuns">
						<a-menu theme="light" mode="inline" :inlineCollapsed="false" v-model="selectedKeys"
							@openChange="onOpenChange" :openKeys="openKeys">
							<template v-for="(m, index) in menus">
								<a-sub-menu :key="index" v-if="m.children.length > 0">
									<slot slot="title">
										<i :class="'iconfont ' + m.icon" style="margin-right:8px;" />
										<span class="menu-text">{{ m.title }}</span>
									</slot>
									<a-menu-item :key="x.path" v-for="x in m.children" @click="go(x)">
										<span>{{ x.title }}</span>
									</a-menu-item>
								</a-sub-menu>
								<a-menu-item :key="index" v-else @click="go(m)">
									<i :class="'iconfont ' + m.icon" style="margin-right:8px;" />
									<span class="menu-text">{{ m.title }}</span>
								</a-menu-item>
							</template>
						</a-menu>
					</div>
				</a-layout-sider>
			</a-drawer>
		</div>

		<a-layout>
			<a-layout-header>
				<div class="header-one">
					<span>
						<a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="showDrawer" />
					</span>

					<!-- <div class="chinese">
						<a-button @click="changeLocale('en-us')" v-show="this.localeval == 'zh-cn'">
							English
						</a-button>
						<a-button @click="changeLocale('zh-cn')" v-show="this.localeval == 'en-us'">
							中文
						</a-button>
					</div> -->
					<span class="right">
						<span>
							<img class="userImg" src="../assets/usericon.svg" alt="" />
							<!-- <a-avatar :size="24" style="margin-right:8px;" :src="imgs" /> -->
							<!-- <span style="margin-right:20px;">用户名</span> -->
							<a-dropdown>
								<a class="ant-dropdown-link" style="color:#788CA2" @click="(e) => e.preventDefault()">
									{{ loginNames }}
									<a-icon type="down" />
									<!-- {{ this.loginNames }} -->
								</a>

								<a-menu slot="overlay">
									<a-menu-item>
										<a href="javascript:;" @click="loginOut">
											<a-icon type="logout" />
											<span style="marginLeft:8px;fontSize:16px">退出登录</span>
										</a>
									</a-menu-item>
								</a-menu>
							</a-dropdown>
						</span>
					</span>
				</div>
				<!-- <div class="header-two">
					<div class="header-two-item">
						<div id="carouse">
							<div class="brrItem" v-for="(item, index) in brr" :key="index">
								<div @click="navPush(item, index)" :class="actived === index ? 'activesClass' : 'tags'">
									<div class="shan">
										<span>{{ item.name }}</span><span
											:class="actived === index ? 'activeRemoves' : 'remove'"
											@click="removeItem(index)">
											<i :class="'iconfont ' + 'icon-guanbi'"></i>
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div :class="isNoPrevDisabled ? 'doubleLeft cut_disabled' : 'doubleLeft'" @click="cutBtn('prev')">
						<a-icon type="double-left" />
					</div>
					<div :class="
              isNoNextDisabled ? 'doubleRight cut_disabled' : 'doubleRight'
            " @click="cutBtn('next')">
						<a-icon type="double-right" />
					</div>
				</div> -->
			</a-layout-header>
			<a-locale-provider :locale="locale">
				<a-layout-content style="padding: 5px 10px;">
					<router-view v-if="isRouterAlive"></router-view>
				</a-layout-content>
			</a-locale-provider>
			<div v-show="keepWhy" class="keepUrlCss">
				<a href="https://beian.miit.gov.cn" target="_blank" style="color: #909399;">粤ICP备2021017313号</a>
			</div>
		</a-layout>
		<!-- <loginOut v-if="visible" @close="close" :visibles="this.visible"></loginOut> -->
		<a-modal title="退出登录" :visible="visibles" :width="460" @cancel="close" class="action">
			<template slot="footer">
				<a-button type="primary" @click="create" class="sure">确定</a-button>
				<a-button @click="close" class="qu">取消</a-button>
			</template>
			<div class="login">
				<div>确定要退出登录吗?</div>
			</div>
		</a-modal>
	</a-layout>
</template>
<script>
	// import menus from '../commons/menus'
	// import loginOut from '../views/loginOut-modal.vue'

	import zhCN from 'ant-design-vue/es/locale-provider/zh_CN'
	import Cookies from "js-cookie";
	import moment from 'moment'
	import 'moment/locale/zh-cn'
	moment.locale('zh-cn')
	const EN = 'en-us'
	const ZH = 'zh-cn'
	import Mixin from '../commons/mixin'
	export default {
		mixins: [Mixin],
		// components: {
		// 	loginOut,
		// },
		name: 'Home',
		data() {
			return {
				logoWhite: require('../assets/logo-white.svg'),
				locale: zhCN,
				localeval: 'zh-cn',
				imgs: '',
				visibles: false,
				datas: [],
				isRouterAlive: true,
				visible: false,
				defaultSelectedKeys: [this.$route.path],
				openKeys: [''],
				collapsed: false,
				exitConfirm: false,
				menus: [],
				user: {},
				selectedKeys: [],
				loginNames: '',
				arr: [],
				brr: [],
				brrs: [],
				visibleDrawer: false,
				placement: 'left',
				actived: '',
				currentIndex: 0, //默认显示图片
				middle_act: '', //当前导航显示的内容
				spanTitleAct: '', //二级菜单的样式
				slideRight: false, //导航栏滑动左右控制
				timeWidth: '', //监听当导航栏宽度
				timeWidthWhy: false ,//监听是否可以滑动
				keepWhy:false
			}
		},
		activated() {

			this.localeval = localStorage.getItem('localeval')
			this.locale = localStorage.getItem('localeval')
			if (this.locale === EN) {
				moment.locale(EN)
				// this.locale = EN
				this.locale = null
			} else {
				moment.locale(ZH)
				this.locale = zhCN
			}

			// this.imgs = sessionStorage.getItem('userPhoto')

			this.visibles = false
			this.loginNames = sessionStorage.getItem('userNames')

			// console.log(this.loginNames, 'this.loginNames')
			this.renderSelect()


			this.menus = JSON.parse(sessionStorage.getItem('data'))
			this.brrs = JSON.parse(sessionStorage.getItem('brrs')) || []
			if (this.menus != null) {

				if (this.brrs.length == 0) {
					if (this.$route.query.data == undefined) {
						return false
					}
					if (this.$route.query.data[0].title == '后台首页') {
						this.brrs.push(this.$route.query.data[0])
						sessionStorage.setItem('brrs', JSON.stringify(this.brrs))
						this.$router.push('/backstage')
					} else {
						this.brrs.push(this.$route.query.data[0])
						sessionStorage.setItem('brrs', JSON.stringify(this.brrs))
						this.$router.push('/addedServices')
					}
					return false
				}


				if (this.brrs.length == 0) {
					this.brrs.push(this.menus[0])
				}


				let brrsTitleEn = []


				for (let i in this.brrs) {
					if (this.brrs[i].titleEn == this.$route.path) {
						this.middle_act = this.brrs[i].title
						if (this.brrs[i].titleEn == this.$route.path) {
							this.brrs[i].titleNew = this.brrs[i].titleEn
						} else {
							this.brrs[i].titleNew = this.$route.path
						}

						sessionStorage.setItem('middle_i', i)
					}
					brrsTitleEn.push(this.brrs[i].titleEn)
				}

				if (this.brrs[sessionStorage.getItem('middle_i')].titleEn != this.$route.fullPath && this.brrs[
						sessionStorage
						.getItem('middle_i')].title == sessionStorage.getItem('middle_act')) {
					this.brrs[sessionStorage.getItem('middle_i')].fullPath = this.$route.fullPath
				}
				if (this.brrs[sessionStorage.getItem('middle_i')].fullPath != undefined && sessionStorage.getItem(
						'middle_act') == this.brrs[sessionStorage.getItem('middle_i')].title) {
					this.brrs[sessionStorage.getItem('middle_i')].fullPath = this.$route.fullPath
				}
				sessionStorage.setItem('brrs', JSON.stringify(this.brrs))
				if (brrsTitleEn.indexOf("/wantLoanApply") != '-1') {
					if (this.$route.path == '/loanApplyList' || this.$route.path == '/loanApply') {
						this.middle_act = "我要贷款"
					}
				}
				if (brrsTitleEn.indexOf("/haiMaiList") != '-1' || brrsTitleEn.indexOf("/haiMaiApply") != '-1') {
					if (this.$route.path == '/haiMaiList' || this.$route.path == '/haiMaiApply') {
						this.middle_act = "海购卡"
					}
				}
				if (this.middle_act == '') {
					this.middle_act = sessionStorage.getItem('middle_act')
				}
				sessionStorage.setItem('middle_act', this.middle_act)

				for (let [index, i] of this.menus.entries()) {
					if (this.middle_act == '海购卡' || this.middle_act == '后台首页' || this.middle_act == '我要贷款' || this
						.middle_act == '商户入网') {
						this.openKeys = ['']
						this.spanTitleAct = ''
						sessionStorage.setItem('openKeys', JSON.stringify(this.openKeys))
					} else {
						for (let j of i.children) {
							if (j.title == this.middle_act) {
								let openKeys = [index]
								this.spanTitleAct = j.title
								sessionStorage.setItem('openKeys', JSON.stringify(openKeys))
							}
						}
					}

				}
				if (JSON.parse(sessionStorage.getItem('openKeys'))) {
					this.openKeys = JSON.parse(sessionStorage.getItem('openKeys'))
				}
			}


		},
		deactivated() {
			this.visibleDrawer = false
		},
		created() {
		  if(window.location.href.indexOf('58.87.82.42')!=-1||window.location.href.indexOf('m.siweipay.com')!=-1){
			  this.logoWhite=require('../assets/swh.png')
		  					this.keepWhy=true
		  			}
		},
		mounted() {
			try {
				this.menus = this.$route.query.data || JSON.parse(sessionStorage.getItem('data'))
			} catch (e) {} finally {
				if (this.$route.query.data == undefined) {
					return false
				}
				if (this.$route.query.data[0].title == '后台首页' || this.$route.query.data[0].title == '海汇达-后台首页') {
					this.$router.push('/backstage')
				} else {
					console.log('addedServices')
					this.$router.push('/addedServices')
				}
			}
			this.menus.forEach((item) => {
				if (item.title == '后台首页') {
					this.brr.push(item)
					sessionStorage.setItem('brr', JSON.stringify(this.brr))
				}
				if (item.title == '商户服务') {
					this.brr.push(item)
					sessionStorage.setItem('brr', JSON.stringify(this.brr))
				}
			})

		},
		methods: {
			moment,
			cutBtn(type) {
				if (
					(type === 'prev' && this.isNoPrevDisabled) ||
					(type === 'next' && this.isNoNextDisabled)
				) {
					return false
				}
				let items = document.querySelectorAll('.brrItem')
				let width =
					type === 'prev' ?
					items[this.currentPage - 1].offsetWidth :
					items[this.currentPage].offsetWidth
				this.translatePage(type, 'carouse', width)
			},
			changeLocale(localeval) {
				this.localeval = localeval
				if (localeval === EN) {
					localStorage.setItem('localeval', localeval)
					moment.locale(EN)
					this.$i18n.locale = EN
					// this.locale = EN
					this.locale = null
				} else {
					localStorage.setItem('localeval', localeval)
					moment.locale(ZH)
					this.$i18n.locale = ZH
					this.locale = zhCN
				}
			},
			log(e) {},
			navPush(items, index) {
				this.actived = index
				this.$router.push(items.path)
			},
			getMsgFormSon(data) {
				this.visibles = data
			},
			// 海购卡路由跳转
			PostService(x) {
				this.$http
					.get('haicardapplyrecord/list?pageSize=10+&pageIndex=1')
					.then((res) => {
						if (res.data.code == 0) {
							if (res.data.data.length != 0) {
								for (let i of this.brrs) {
									if (i.title == '海购卡') {
										i.titleEn = '/haiMaiList'
									}
								}
								this.$router.push({
									path: '/haiMaiList'
								})
							} else {
								for (let i of this.brrs) {
									if (i.title == '海购卡') {
										i.titleEn = '/haiMaiApply'
									}
								}
								this.$router.push({
									path: '/haiMaiApply'
								})
							}
							sessionStorage.setItem('brrs', JSON.stringify(this.brrs))
						} else if (res.data.code == 600) {
							this.$message.info('请登录')
						} else {
							this.$message.warning(res.data.msg)
						}
					})
			},

			close() {
				this.visibles = false
			},
			create() {
				this.$http.get('sys/loginOut').then((res) => {
					if (res.data.code == 0) {
						this.visibles = false
						sessionStorage.clear()
						Cookies.remove('token')
						this.$router.push({
							path: '/login'
						})
					} else if (res.data.code == 600) {
						this.$message.info('请登录')
					} else {
						this.$message.info(res.data.msg)
					}
				})
			},
			loginOut() {
				this.visibles = true
				// this.$router.push({path:"/"})
			},
			go(x) {
				if (x.title == '海购卡' || x.title == '后台首页' || x.title == '我要贷款' || x.title == '商户入网') {
					this.openKeys = ['']
					sessionStorage.setItem('openKeys', JSON.stringify(this.openKeys))
				}
				let brrsTitle = []
				for (let i of this.brrs) {
					brrsTitle.push(i.title)
				}
				if (brrsTitle.indexOf(x.title) == '-1') {
					this.brrs.push(x)
				}

				if (x.title == "海购卡") {
					this.PostService(x)

					return false
				}
				sessionStorage.setItem('brrs', JSON.stringify(this.brrs))

				if (x.title == '商户入网') {
					this.actived = this.brr.length
				} else if (x.title == '后台首页') {
					this.reflags = false
					this.actived = this.brr.length
				} else {
					this.reflags = true
					this.brr.push(x)
					this.actived = this.brr.length - 1
					this.brr = [...new Set(this.brr)]

					sessionStorage.setItem('brr', JSON.stringify(this.brr))
				}
				const pathname = window.location.pathname
				if (x.titleEn !== pathname) {

					this.$router.replace(x.titleEn)
				}
			},
			removeItem(index) {
				this.brr.splice(index, 1)
				this.dynamicSetWidth('carouse', '.brrItem', 'del')
				if (index == this.brr.length) {
					this.cutBtn('prev')
				}
			},
			gotoPage(index) {
				this.currentIndex = index
			},
			login() {
				// todo
				sessionStorage.clear()
				this.$router.push({
					path: '/login'
				})
			},
			renderSelect() {
				const pathname = window.location.pathname
				this.selectedKeys = [pathname]
			},
			onOpenChange(openKeys) {
				// 当菜单被展开时触发此处
				/*
				      经测试传入的变量openKeys是数组 点击已经展开的菜单时传入的是空数组
				      点击未展开的菜单时传入的是[当前展开菜单的key,点击的菜单key]
				      下面的if判断用openKeys === [] 无效 所以我只能判断数组length是否等于0
				      */
				if (openKeys.length !== 0) {
					this.openKeys = [openKeys[1]]
				} else {
					this.openKeys = ['']
				}
			},
			showDrawer() {
				// this.collapsed = !this.collapsed
				this.visibleDrawer = true
			},
			onClose() {
				this.visibleDrawer = false
			},
			onChange(e) {
				this.placement = e.target.value
			},
		},
		watch: {
			$route(to, from) {
				this.renderSelect()
			},
		},
	}
</script>
<style lang="less" scoped>
	.keepUrlCss{
		width: 100%;
		    text-align: center;
		    font-size: 14px;
		    padding: 5px 0;
		    background: #ffffff;
		    position: fixed;
		    bottom: 0;
	}
	.smart-home {
		width: 100%;
		height: 100%;

		// position: relative;
		&-left {
			width: 100%;
			height: 100%;
		}

		// .ant-layout-sider {
		//   position: absolute;
		//   left: 0px;

		//   height: 100%;
		//   overflow: auto;
		// }

		.ant-layout-header {
			// height: 100px;
			z-index: 99;
			margin-bottom: 10px;
			background: rgb(255, 255, 255);
			padding: 0px;
			display: flex;
			// justify-content: space-between;
			// align-items: center;
			flex-flow: column;
			box-shadow: 0px 0px 8px 0px rgba(67, 96, 218, 0.13);
			// position: relative;
		}

		.right {
			position: absolute;
			right: 10px;
		}

		.ant-layout-content {
			position: relative;
			height: calc(~'100% - 100px');
			// overflow: hidden;
			background: #eff3fa;
		}

		// .meuns {
		//   height: calc(~'100% - 80px');
		//   overflow-y: auto !important;
		// }

		.logo-text,
		.menu-text {
			opacity: 1;
			transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
				width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		}

		.ant-layout-sider-collapsed {

			.logo-text,
			.menu-text {
				display: inline-block;
				max-width: 0;
				opacity: 0;
			}
		}
	}

	.meuns {
		height: calc(~'100% - 80px');
		overflow-y: auto;
	}

	.chinese {
		position: absolute;
		top: 17px;
		left: 70px;
		width: 100px;
		height: 32px;
		line-height: 32px;
	}

	.middle {
		padding: 0px 15px;
	}

	.ant-tag {
		border: none !important;
		font-size: 14px !important;
		padding: 5px 7px !important;
	}

	.ant-layout-sider {
		background: #fff !important;
	}

	.trigger {
		margin-left: 25px;
	}

	.ant-dropdown-link {
		font-size: 14px;
	}

	.header-one {
		width: 100%;
		height: 60px;
		// border-bottom: 1px solid #e9f0f5;
		position: relative;
	}

	.ant-layout-sider-children .logo {
		// position: fixed;
		height: 60px;
		line-height: 60px;
		box-sizing: border-box;

		img {
			margin-left: 20px;
		}
	}

	.header-two {
		width: 100%;
		height: 40px;
		line-height: 40px;
		padding: 0px 5px;
		color: #788ca2;
		font-size: 14px;
		box-sizing: border-box;

		// overflow: hidden;
		position: relative;

		&-item {
			width: 80%;
			margin-left: 10%;

			#carouse {
				width: auto;
				// display: flex;
				height: 40px;
				flex-shrink: 0;
				// padding: 0 68px;
				box-sizing: border-box;
				transition: all 0.4s linear;
			}

			.tags {
				border-top: 2px solid#fff;
				display: inline-block;
				height: 40px;
				background: #fff;
				line-height: 40px;
				padding: 0px 24px;

				// margin-left: 1px;
				.remove {
					display: inline-block;
					width: 15px;
					height: 15px;
					line-height: 40px;
					margin-left: 15px;
					text-align: center;
					font-size: 7px;
				}
			}
		}

		.doubleLeft {
			text-align: center;
			height: 40px;
			width: 40px;
			background: #fff;
			position: absolute;
			left: 0px;
			top: 0px;
		}

		.doubleRight {
			text-align: center;
			height: 40px;
			width: 40px;
			position: absolute;
			right: 0px;
			top: 0px;
			background: #fff;
		}

		.cut_disabled {
			background: #ddd;
		}
	}

	.shan {
		display: flex;
		flex-flow: row nowrap;

		span {
			flex-shrink: 0;
		}
	}

	.activesClass {
		display: inline-block;
		height: 40px;
		background: #fff;
		line-height: 40px;
		padding: 0px 24px;
		border-top: 2px solid#5575E9;
		background: #f6f8fc;
	}

	.activeRemoves {
		width: 15px;
		height: 15px;
		text-align: center;
		display: inline-block;
		color: #5575e9;
		// border-radius: 50%;
		// color: #5575e9;
		// background: #5575e9;
		line-height: 40px;
		font-size: 7px;
		margin-left: 15px;
	}

	.ant-carousel .slick-slide {
		width: 166px !important;
		text-align: center;
		height: 40px;
		line-height: 40px;
		background: #364d79;
		overflow: hidden;
	}

	.brrItem {
		width: auto;
		height: 40px;
		white-space: normal;
		display: inline;
		float: left;
		// margin-left: 10%;
		// display: flex;
		// flex-flow: row nowrap;
		// flex-shrink: 0;
	}

	#carouse .brrItem:first-child {
		// margin-left: 20px;
	}

	.ant-carousel .custom-slick-arrow {
		width: 25px;
		height: 25px;
		font-size: 25px;
		// color: red;
		color: #000;

		opacity: 0.3;
	}

	.ant-carousel .custom-slick-arrow:before {
		display: none;
	}

	// .ant-carousel .slick-slide h3 {
	//   text-align: center;
	//   width: 80%;
	//   margin-left: 10%;
	//   color: #000;
	// }
	.login {
		width: 100%;
		color: #252631;
		text-align: center;
		font-size: 14px;
	}

	.smart-form-inline {
		.ant-form-item {
			display: flex;

			margin-bottom: 12px;
		}

		.ant-form-item-label {
			min-width: 90px;
		}

		.ant-form-item-control-wrapper {
			flex: 1;
		}
	}

	.sure.ant-btn-primary {
		border-radius: 16px !important;
		background: #5575e9;
		border: none;
	}

	.qu.ant-btn {
		border-radius: 16px;

		color: #384c6d;
		background: #ffffff;
		border: 1px solid #e2e9ee;
	}

	.iconfont {
		cursor: pointer;
	}
	.userImg {
		width: 24px;
		height: 24px;
		margin-right: 8px;
	}
</style>
